import { ChangeEvent, useCallback, useRef, useState } from "react";
import { ControlStaticType, FormControlChildProps } from "../form-control";
import clsx from "clsx";

export interface CustomRadioProps extends FormControlChildProps {
  label?: string;

  value?: string | number;

  defaultChecked?: boolean;

  className?: string;

  labelClassName?: string;

  outerClassName?: string;

  innerClassName?: string;

  isMultiLanguage?: boolean;

  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;

  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export default function CustomRadio({
  id,
  className,
  labelClassName = "",
  outerClassName,
  innerClassName,
  label,
  name,
  value,
  disabled = false,
  checked,
  defaultChecked = false,
  onChange,
  onBlur,
  fmOnChange,
  fmOnBlur,
}: CustomRadioProps) {
  const radioRef = useRef<HTMLInputElement>(null);
  const [innerChecked, setCheckedState] = useState(defaultChecked);
  let isChecked = checked !== undefined ? checked : innerChecked;

  if (radioRef.current && checked === undefined) {
    isChecked = radioRef.current.checked;
  }

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(e);

      fmOnChange && fmOnChange(e);

      setCheckedState(e.target.checked);
    },
    [fmOnChange, onChange]
  );

  const handleBlur = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onBlur && onBlur(e);

      fmOnBlur && fmOnBlur(e);
    },
    [fmOnBlur, onBlur]
  );

  return (
    <label htmlFor={id} className={`flex items-center ${className}`}>
      <input
        id={id}
        ref={radioRef}
        className="hidden"
        type="radio"
        value={value}
        name={name}
        checked={isChecked}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <span
        className={`relative w-5 h-5 border-[2px] border-[#3A4251] rounded-full cursor-pointer ${outerClassName}`}
      >
        <span
          className={clsx(
            "absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]",
            `w-3 h-3 rounded-full bg-[#3A4251] hidden ${innerClassName}`,
            {
              "!block": isChecked,
            }
          )}
        ></span>
      </span>
      {!!label && (
        <p
          className={`text-[#666] pl-[10px] text-[15px] cursor-pointer ${labelClassName}`}
        >
          {label}
        </p>
      )}
    </label>
  );
}

CustomRadio.staticType = ControlStaticType.RADIO;
